import { render } from "./SelectTypes.vue?vue&type=template&id=baccfc3e"
import script from "./SelectTypes.vue?vue&type=script&lang=js"
export * from "./SelectTypes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__